import type { ComponentChildren } from "preact";
import {
  Loading as AdminLoading,
  Notice as AdminNotice,
  StatusBadge,
} from "cfw-lib-admin-ui/preact";
import {
  AlertCircle,
  CheckCircle2,
  Clock3,
  Globe,
  LoaderCircle,
} from "lucide-react";
import type { MapSummary } from "../shared/types";

export { PageTitle, PageHeading } from "cfw-lib-admin-ui/preact";

export function Status({ map }: { map: MapSummary }) {
  const published = map.publishedRevision !== null;
  const pending = published && map.publishedRevision !== map.revision;
  return (
    <StatusBadge
      className="em-status"
      tone={published ? (pending ? "warning" : "success") : "neutral"}
      icon={published && !pending ? <Globe size={13} /> : <Clock3 size={13} />}
    >
      {published ? (pending ? "Unpublished changes" : "Published") : "Draft"}
    </StatusBadge>
  );
}
export function Notice({
  children,
  success = false,
}: {
  children: ComponentChildren;
  success?: boolean;
}) {
  return (
    <AdminNotice
      className="em-notice"
      tone={success ? "success" : "error"}
      icon={success ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />}
    >
      {children}
    </AdminNotice>
  );
}
export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <AdminLoading
      className="em-loading"
      label={label}
      icon={<LoaderCircle size={23} className="em-spin" />}
    />
  );
}
export function updatedDate(date: string) {
  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
}
export function download(
  name: string,
  text: string,
  type = "application/json",
) {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
